@if (hasSigners()) {
  <div class="signer-roster">
    <h3 class="h4-500 color-gray-100 roster-heading">Review &amp; Sign</h3>

    <div class="d-flex align-items-center justify-content-between roster-row" dataSelector="esign-signatures-required">
      <span class="body-300 color-gray-100">Signatures required</span>
      <span class="body-300 color-gray-100">{{ signers().length }}</span>
    </div>

    @for (signer of signers(); track $index) {
      <div class="d-flex align-items-center justify-content-between roster-row" [dataSelector]="'esign-signer-row-' + $index">
        <span class="body-300 color-gray-100">{{ signer.displayName }}</span>
        <pill [value]="statusLabel(signer)" [color]="statusColor(signer)" size="small"></pill>
      </div>
    }
  </div>
}
